module.exports = __webpack_public_path__ + "img/金币.81c003b2.png";